// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9U8WS","importantInfo":"styles_importantInfo__2sCjK"};